import { useMcClient } from 'utils/api/query/McClientContext'

export const useMcClientAPI = () => {
  return useMcClient().api
}
